var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { shapes, util } from '@joint/plus';
var Link = /** @class */ (function (_super) {
    __extends(Link, _super);
    function Link() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Link.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'mapping.Link',
            z: -1,
            attrs: {
                line: {
                    targetMarker: {
                        'type': 'path',
                        'd': 'M 10 -5 0 0 10 5 z'
                    },
                    sourceMarker: {
                        'type': 'path',
                        'd': 'M 0 -5 10 0 0 5 z'
                    },
                    stroke: '#7C90A6',
                    strokeWidth: 1
                }
            }
        }, _super.prototype.defaults);
    };
    return Link;
}(shapes.standard.Link));
export { Link };
var Constant = /** @class */ (function (_super) {
    __extends(Constant, _super);
    function Constant() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Constant.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'mapping.Constant',
            itemHeight: 20,
            itemOffset: 5,
            itemMinLabelWidth: 10,
            itemIcon: { padding: 4 },
            attrs: {
                root: {
                    magnet: false
                },
                body: {
                    stroke: '#EBEEF0'
                },
                itemLabels: {
                    fontSize: 12,
                    fontFamily: 'Sans-serif',
                },
                itemLabels_1: {
                    magnet: true
                },
                itemBodies_0: {
                    stroke: '#7C90A6'
                },
                itemBodies: {
                    stroke: 'none'
                }
            },
            items: [
                [{
                        id: 'icon',
                        icon: 'assets/images/clipboard.svg',
                    }],
                [{
                        id: 'value',
                        label: '',
                        span: 2
                    }],
                []
            ]
        }, _super.prototype.defaults);
    };
    Constant.prototype.setValue = function (value, opt) {
        return this.prop(['items', 1, 0, 'label'], '"' + value + '"', opt);
    };
    Constant.prototype.getDefaultItem = function () {
        return {
            id: util.uuid(),
            label: '""',
            icon: 'assets/images/clipboard.svg'
        };
    };
    Constant.prototype.getItemTools = function () {
        return [
            { action: 'edit', content: 'Edit Constant' }
        ];
    };
    Constant.prototype.getTools = function () {
        return [
            { action: 'remove', content: warning('Remove Constant') }
        ];
    };
    Constant.prototype.getInspectorConfig = function () {
        return {
            label: {
                label: 'Label',
                type: 'content-editable'
            }
        };
    };
    return Constant;
}(shapes.standard.BorderedRecord));
export { Constant };
var Concat = /** @class */ (function (_super) {
    __extends(Concat, _super);
    function Concat() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Concat.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'mapping.Concat',
            itemHeight: 20,
            itemOffset: 5,
            padding: { top: 35, left: 10, right: 0, bottom: 0 },
            itemMinLabelWidth: 50,
            itemOverflow: true,
            attrs: {
                root: {
                    magnet: false
                },
                body: {
                    stroke: '#EBEEF0'
                },
                header: {
                    height: 35,
                    fill: '#F8FAFC',
                    stroke: '#EBEEF0'
                },
                tabColor: {
                    height: 5,
                    x: 0,
                    y: 0,
                    width: 'calc(w)',
                    fill: '#FF4365',
                    stroke: '#FF4365'
                },
                headerLabel: {
                    y: 5,
                    fontFamily: 'Sans-serif',
                    fontWeight: 300,
                    textWrap: {
                        text: 'concat',
                        ellipsis: true,
                        height: 30
                    }
                },
                itemLabels: {
                    magnet: true,
                    fontSize: 12,
                    fontFamily: 'Sans-serif',
                },
                itemLabels_0: {
                    magnet: 'passive',
                    cursor: 'pointer'
                },
                itemBodies_0: {
                    stroke: '#EBEEF0'
                }
            },
            items: [
                [{
                        id: 'value_1',
                        label: 'Value 1',
                        icon: 'assets/images/link.svg',
                    }, {
                        id: 'value_2',
                        label: 'Value 2',
                        icon: 'assets/images/link.svg',
                    }, {
                        id: 'value_3',
                        label: 'Value 3',
                        icon: 'assets/images/link.svg',
                    }], [{
                        id: 'result',
                        label: 'Result ⇛',
                        height: 40
                    }]
            ]
        }, _super.prototype.defaults);
    };
    Concat.prototype.preinitialize = function () {
        this.markup = [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'rect',
                selector: 'header'
            }, {
                tagName: 'rect',
                selector: 'tabColor'
            }, {
                tagName: 'text',
                selector: 'headerLabel'
            }];
    };
    Concat.prototype.getNumberOfValues = function () {
        return this.prop(['items', 0]).length;
    };
    Concat.prototype.getDefaultItem = function () {
        return {
            id: util.uuid(),
            label: 'Value ' + (this.getNumberOfValues() + 1),
            icon: 'assets/images/link.svg'
        };
    };
    Concat.prototype.getItemTools = function (itemId) {
        var groupIndex = this.getItemGroupIndex(itemId);
        if (groupIndex !== 0)
            return null;
        var tools = [
            { action: 'edit', content: 'Edit Value' },
            { action: 'add-next-sibling', content: 'Add Value' }
        ];
        if (this.getNumberOfValues() > 2) {
            tools.push({ action: 'remove', content: warning('Remove Value') });
        }
        tools.push();
        return tools;
    };
    Concat.prototype.getTools = function () {
        return [
            { action: 'add-item', content: 'Add Value' },
            { action: 'remove', content: warning('Remove Concat') }
        ];
    };
    Concat.prototype.getInspectorConfig = function (itemId) {
        var groupIndex = this.getItemGroupIndex(itemId);
        if (groupIndex !== 0)
            return null;
        return {
            label: {
                label: 'Label',
                type: 'content-editable'
            }
        };
    };
    return Concat;
}(shapes.standard.HeaderedRecord));
export { Concat };
var GetDate = /** @class */ (function (_super) {
    __extends(GetDate, _super);
    function GetDate() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GetDate.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'mapping.GetDate',
            itemHeight: 20,
            itemOffset: 5,
            padding: { top: 35, left: 10, right: 0, bottom: 0 },
            itemMinLabelWidth: 50,
            itemOverflow: true,
            attrs: {
                root: {
                    magnet: false
                },
                body: {
                    stroke: '#EBEEF0'
                },
                header: {
                    height: 35,
                    fill: '#F8FAFC',
                    stroke: '#EBEEF0'
                },
                tabColor: {
                    height: 5,
                    x: 0,
                    y: 0,
                    width: 'calc(w)',
                    fill: '#00BC9A',
                    stroke: '#00BC9A'
                },
                headerLabel: {
                    y: 5,
                    fontFamily: 'Sans-serif',
                    fontWeight: 300,
                    textWrap: {
                        text: 'get-date',
                        ellipsis: true,
                        height: 30
                    }
                },
                itemLabels: {
                    magnet: true,
                    fontSize: 12,
                    fontFamily: 'Sans-serif',
                },
                itemLabels_0: {
                    magnet: 'passive',
                    cursor: 'pointer'
                },
                itemBodies: {
                    stroke: '#EBEEF0'
                }
            },
            items: [
                [{
                        id: 'value',
                        label: '⇛ Value',
                        height: 60
                    }],
                [{
                        id: 'year',
                        label: 'year',
                        icon: 'assets/images/link.svg',
                    }, {
                        id: 'month',
                        label: 'month',
                        icon: 'assets/images/link.svg',
                    }, {
                        id: 'day',
                        label: 'day',
                        icon: 'assets/images/link.svg',
                    }]
            ]
        }, _super.prototype.defaults);
    };
    GetDate.prototype.preinitialize = function () {
        this.markup = [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'rect',
                selector: 'header'
            }, {
                tagName: 'rect',
                selector: 'tabColor'
            }, {
                tagName: 'text',
                selector: 'headerLabel'
            }];
    };
    GetDate.prototype.getDefaultItem = function () {
        return {
            id: util.uuid(),
            label: 'item',
            icon: 'assets/images/document.svg'
        };
    };
    GetDate.prototype.getItemTools = function () {
        return null;
    };
    GetDate.prototype.getTools = function () {
        return [
            { action: 'remove', content: warning('Remove GetDate') }
        ];
    };
    GetDate.prototype.getInspectorConfig = function () {
        return null;
    };
    return GetDate;
}(shapes.standard.HeaderedRecord));
export { GetDate };
var Record = /** @class */ (function (_super) {
    __extends(Record, _super);
    function Record() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Record.prototype.defaults = function () {
        return util.defaultsDeep({
            type: 'mapping.Record',
            itemHeight: 20,
            itemOffset: 15,
            itemMinLabelWidth: 70,
            itemAboveViewSelector: 'header',
            itemBelowViewSelector: 'footer',
            padding: { top: 35, left: 15, right: 10, bottom: 10 },
            scrollTop: 0,
            size: { height: 300 },
            itemOverflow: true,
            attrs: {
                root: {
                    magnet: false
                },
                body: {
                    stroke: '#EBEEF0'
                },
                header: {
                    height: 35,
                    fill: '#F8FAFC',
                    stroke: '#EBEEF0'
                },
                tabColor: {
                    height: 5,
                    x: 0,
                    y: 0,
                    width: 'calc(w)',
                    fill: '#4566E5',
                    stroke: '#4566E5'
                },
                headerLabel: {
                    y: 5,
                    fontFamily: 'Sans-serif',
                    fontWeight: 300,
                    textWrap: {
                        ellipsis: true,
                        height: 30
                    }
                },
                footer: {
                    height: 10,
                    x: 0,
                    y: 'calc(h - 10)',
                    width: 'calc(w)',
                    fill: '#F8FAFC',
                    stroke: '#EBEEF0'
                },
                buttonsGroups: {
                    stroke: '#7C90A6'
                },
                forksGroups: {
                    stroke: 'lightgray'
                },
                itemBodies: {
                    itemHighlight: {
                        fill: 'none'
                    }
                },
                itemLabels: {
                    magnet: 'true',
                    cursor: 'pointer',
                    fontSize: 12,
                    fontFamily: 'Sans-serif',
                    itemHighlight: {
                        fill: '#4566E5'
                    }
                },
                itemLabels_disabled: {
                    magnet: null,
                    fill: '#AAAAAA',
                    cursor: 'not-allowed'
                }
            }
        }, _super.prototype.defaults);
    };
    Record.prototype.preinitialize = function () {
        this.markup = [{
                tagName: 'rect',
                selector: 'body'
            }, {
                tagName: 'rect',
                selector: 'header'
            }, {
                tagName: 'rect',
                selector: 'tabColor'
            }, {
                tagName: 'text',
                selector: 'headerLabel'
            }, {
                tagName: 'rect',
                selector: 'footer'
            }];
    };
    Record.prototype.setName = function (name, opt) {
        return this.attr(['headerLabel', 'textWrap', 'text'], name, opt);
    };
    Record.prototype.getDefaultItem = function () {
        return {
            id: util.uuid(),
            label: 'new_item',
            icon: 'assets/images/document.svg'
        };
    };
    Record.prototype.getItemTools = function () {
        return [
            { action: 'edit', content: 'Edit Item' },
            { action: 'edit-decorator', content: 'Edit Decorator' },
            { action: 'add-child', content: 'Add Child' },
            { action: 'add-next-sibling', content: 'Add Next Sibling' },
            { action: 'add-prev-sibling', content: 'Add Prev Sibling' },
            { action: 'remove', content: warning('Remove Item') }
        ];
    };
    Record.prototype.getTools = function () {
        return [
            { action: 'add-item', content: 'Add Child' },
            { action: 'remove', content: warning('Remove Record') }
        ];
    };
    Record.prototype.getInspectorConfig = function () {
        return {
            label: {
                label: 'Label',
                type: 'content-editable'
            },
            icon: {
                label: 'Icon',
                type: 'select-button-group',
                options: [{
                        value: 'assets/images/link.svg',
                        content: '<img height="42px" src="assets/images/link.svg"/>'
                    }, {
                        value: 'assets/images/document.svg',
                        content: '<img height="42px" src="assets/images/document.svg"/>'
                    }, {
                        value: 'assets/images/clipboard.svg',
                        content: '<img height="42px" src="assets/images/clipboard.svg"/>'
                    }, {
                        value: 'assets/images/file.svg',
                        content: '<img height="42px" src="assets/images/file.svg"/>'
                    }]
            },
            highlighted: {
                label: 'Highlight',
                type: 'toggle'
            }
        };
    };
    return Record;
}(shapes.standard.HeaderedRecord));
export { Record };
function warning(text) {
    return '<span style="color:#fe854f">' + text + '</span>';
}
var ConstantView = shapes.standard.RecordView;
var ConcatView = shapes.standard.RecordView;
var GetDateView = shapes.standard.RecordView;
var RecordView = shapes.standard.RecordView;
export var cellNamespace = __assign(__assign({}, shapes), { mapping: {
        Link: Link,
        Constant: Constant,
        ConstantView: ConstantView,
        Concat: Concat,
        ConcatView: ConcatView,
        GetDate: GetDate,
        GetDateView: GetDateView,
        Record: Record,
        RecordView: RecordView
    } });
